module.exports = __webpack_public_path__ + "img/btn_naptien.4298319c.svg";